import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from '../../../store/actions';
import EnhancedTableHead from "../../../UI/MaterialTableOverrides/EnhancedTableHead";
import TablePaginationActionsWrapped from "../../../UI/MaterialTableOverrides/TablePaginationActions";
import {
  Button, Table, TableBody, TableRow, TableCell, TableFooter, TablePagination, Drawer, Paper, CircularProgress, Typography, Chip
} from '@mui/material';
import { FilterList } from '@mui/icons-material'
import moment from 'moment';
import TabsEquipment from '../../../components/Tabs/TabsEquipment';
import ModalFilter from '../ModalFilter/ElementLogs/index'
import LogModal from '../Modals/Log/index';
import TableTitle from '../../../UI/MaterialTableOverrides/TableTitle';
import { isEmpty } from 'lodash'

function LogsEquipment(props) {
  const dispatch = useDispatch();
  let textInput = useRef(null);
  const elementId = props.match.params.id;
  const path = props.match.path;

  const [page, setPage] = useState(1);
  const [alreadySearched, setAlreadySearched] = useState(false);
  const [limit, setLimit] = useState(25);
  const [searchText, setSearchText] = useState("");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [order, setOrder] = useState("desc");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [filteredStartDate, setFilteredStartDate] = useState(null)
  const [filteredEndDate, setFilteredEndDate] = useState(null)
  const [filteredUsers, setFilteredUsers] = useState([])
  const [filteredTypes, setFilteredTypes] = useState([])
  const [filteredOperationsName, setFilteredOperationsName] = useState([])
  const [filteredTables, setFilteredTables] = useState([])

  const elementFilters = useSelector(state => state.logs.elementFilter);

  const loading = useSelector(state => state.logs.employeeLoading);
  const tenantFeatureFlags = useSelector(state => state.auth.selectedAccess.tenant.tenantFeatureFlags);

  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  if (selectedAccess.role !== 'admin') props.history.push('/');

  const fetchLogs = useCallback(() => dispatch(actions.fetchLogsByElementId(page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, elementId)),
    [page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, elementId]
  );

  const logs = useSelector(state => state.logs.employeeLogs);

  const headRows = [
    { id: "createdAt", numeric: false, disablePadding: false, label: "Data de criação" },
    { id: "type", numeric: false, disablePadding: false, label: "Tipo" },
    { id: "table", numeric: false, disablePadding: false, label: "Tabela" },
    { id: "operationName", numeric: false, disablePadding: false, label: "Tipo de operação" },
    { id: "dcumentId", numeric: false, disablePadding: false, label: "ID do document" },
    { id: "user", numeric: false, disablePadding: false, label: "Usúario" },
    { id: "role", numeric: false, disablePadding: false, label: "Função" },
  ];

  const populateFilters = () => {
    setFilteredStartDate(elementFilters.startDate);
    setFilteredEndDate(elementFilters.endDate);
    setFilteredUsers(elementFilters.filteredUsers);
    setFilteredTypes(elementFilters.filteredTypes);
    setFilteredOperationsName(elementFilters.filteredOperationsName);
    setFilteredTables(elementFilters.filteredTables);
  }

  useEffect(() => {
    // dispatch(actions.showSearchNavbarText(false));
    setPage(elementFilters.page);
    setLimit(elementFilters.limit);
    setSearchText(elementFilters.search);
    setOrderBy(elementFilters.orderBy);
    setOrder(elementFilters.order);
  }, []);

  useEffect(() => {
    if (!isEmpty(elementFilters) && !isFilterOpen) populateFilters();
  }, [elementFilters])

  useEffect(() => {
    fetchLogs();
    setAlreadySearched(true);
  }, [page, limit, order, orderBy]);

  useEffect(() => {
    if (searchText !== "" || alreadySearched) {
      const timer = setTimeout(() => {
        if (searchText === textInput.current.value) {
          fetchLogs();
        }
      }, 200);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [searchText, textInput]);


  useEffect(() => {
		return () => {
			dispatch(actions.setLogsFilter(page, limit, searchText, order, orderBy, null, null, [], [], [], [], []))
		};
	}, []);

  const handleChangePage = (e, page) => {
    setPage(page + 1);
  };

  const handleChangeRowsPerPage = e => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };

  const selectRow = (e, id) => {
    dispatch(actions.fetchLogsById(id));
    setIsLogModalOpen(true);
  }

  const deleteFilteredStartDate = () => {
    dispatch(actions.triggerRemoveElementLogsStartDateFilter(page, limit, searchText, order, orderBy, filteredEndDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, elementId))
  }

  const deleteFilteredEndDate = () => {
    dispatch(actions.triggerRemoveElementLogsEndDateFilter(page, limit, searchText, order, orderBy, filteredStartDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, elementId))
  }

  const deleteFilteredUsers = (user) => {
    dispatch(actions.triggerRemoveElementUsersFilter(page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, user, elementId))
  }

  const deleteFilteredTypes = (type) => {
    dispatch(actions.triggerRemoveElementTypesFilter(page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, type, elementId))
  }

  const deleteFilteredOperationsName = (operationName) => {
    dispatch(actions.triggerRemoveElementOperationsNameFilter(page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, operationName, elementId))
  }

  const deleteFilteredTables = (table) => {
    dispatch(actions.triggerRemoveElementTablesFilter(page, limit, searchText, order, orderBy, filteredStartDate, filteredEndDate, filteredUsers, filteredTypes, filteredOperationsName, filteredTables, table, elementId))
  }

  const renderStartDateChip = () => (filteredStartDate && <Chip
    label={`Data de criação De: ${moment(filteredStartDate).format('DD/MM/YYYY - HH:mm:ss')}`}
    onDelete={() => deleteFilteredStartDate()}
    style={styles.filterChip} />)
  const renderEndDateChip = () => (filteredEndDate && <Chip
    label={`Vencimento Até: ${moment(filteredEndDate).format('DD/MM/YYYY - HH:mm:ss')}`}
    onDelete={() => deleteFilteredEndDate()}
    style={styles.filterChip} />)
  const renderUsersChip = () => (filteredUsers && filteredUsers.map((user) => (<Chip
    key={user.value}
    label={user.label}
    onDelete={() => deleteFilteredUsers(user)}
    style={styles.filterChip} />)))
  const renderTypesChip = () => (filteredTypes && filteredTypes.map((type) => (<Chip
    key={type.value}
    label={type.label}
    onDelete={() => deleteFilteredTypes(type)}
    style={styles.filterChip} />)))
  const renderOperationsNameChip = () => (filteredOperationsName && filteredOperationsName.map((operationName) => (<Chip
    key={operationName.value}
    label={operationName.label}
    onDelete={() => deleteFilteredOperationsName(operationName)}
    style={styles.filterChip} />)))
  const renderTablesChip = () => (filteredTables && filteredTables.map((table) => (<Chip
    key={table.value}
    label={table.label}
    onDelete={() => deleteFilteredTables(table)}
    style={styles.filterChip} />)))

  const handleClickClearFilters = () => {
    dispatch(actions.clearLogsByElementIdFilter(page, limit, searchText, order, orderBy, elementId));
  };

  const clearFilterButton = () => {
    if ((filteredStartDate)
      || (filteredEndDate)
      || (filteredUsers && filteredUsers.length > 0)
      || (filteredTypes && filteredTypes.length > 0)
      || (filteredOperationsName && filteredOperationsName.length > 0)
      || (filteredTables && filteredTables.length > 0))
      return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>Limpar</Typography>;
  };

  return <>
  <TabsEquipment
    {...props}
    selected={'logsTab'}
  />

<Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}>
      <ModalFilter
        closeModal={() => setIsFilterOpen(false)}
        path={props.match.path}
        elementId={elementId}
      />
    </Drawer>
    <Drawer
      BackdropProps={{ invisible: true }}
      variant="temporary"
      anchor="right"
      onClose={() => setIsLogModalOpen(false)}
      open={isLogModalOpen}>
      <LogModal
        closeModal={() => setIsLogModalOpen(false)}
      />
      </Drawer>
<div style={styles.container}>
      <Paper>
      <TableTitle
          title='Logs'
          placeholder='Pesquisar'
          inputRef={textInput}
          value={searchText}
          onChange={event => {
            setPage(1);
            setSearchText(event.target.value);
          }}
        />
        <div style={styles.filterChipContainer}>
          <Button
            variant='contained'
            onClick={() => setIsFilterOpen(true)}
            style={styles.buttonFilter}>
            filtros <FilterList style={styles.buttonFilterIcon} />
          </Button>
          {renderStartDateChip()}
          {renderEndDateChip()}
          {renderUsersChip()}
          {renderTypesChip()}
          {renderOperationsNameChip()}
          {renderTablesChip()}
          {clearFilterButton()}
        </div>
        <Table style={styles.table}>
          <tbody>
            <tr>
              <td>
                {loading &&
                  <div style={styles.spinner}>
                    <CircularProgress />
                  </div>}
                {logs.rows.length === 0 &&
                  <div style={styles.noResults}>
                    {!loading && <Typography style={styles.spinner}>Nenhum resultado encontrado</Typography>}
                  </div>}
              </td>
            </tr>
          </tbody>
          <EnhancedTableHead
            style={{ opacity: loading ? '0.3' : '1' }}
            headRows={headRows}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody style={{ opacity: loading ? '0.3' : '1' }}>
            {logs.rows.map(log => ({...log, tenantFeatureFlags})).map((log, index) => {
              return (
                <TableRow
                  style={styles.tableRow}
                  key={log._id}
                  hover
                  onClick={event => selectRow(event, log._id)}
                >
                  <TableCell style={styles.cell}>
                    <div style={styles.statusContainer}>
                      {<span style={styles.label}>{moment(log.createdAt).format('DD/MM/YYYY - HH:mm:ss')}</span>}
                    </div>
                  </TableCell>
                  <TableCell style={styles.cell}>
                                              {log.type}
                                      </TableCell>
                  <TableCell style={styles.cell}>
                    <div>{log.table}</div>
                  </TableCell>
                  <TableCell style={styles.cell}>
                    <div>{log.operationName}</div>
                  </TableCell>
                  <TableCell style={styles.cell}>
                    <div>{log.documentId}</div>
                  </TableCell>
                  <TableCell style={styles.cell}>
                    <div>{log.user ? log.user.name : (log.apiKey ? 'apiKey' : 'public')}</div>
                  </TableCell>
                  <TableCell style={styles.cell}>
                    <div>{log.role ? log.role : '-'}</div>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
          <TableFooter style={{ opacity: loading ? '0.3' : '1' }}>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[25, 50]}
                count={logs.count}
                rowsPerPage={parseInt(limit)}
                page={page - 1}
                SelectProps={{
                  native: true
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    </div>

  </>;
}

export default LogsEquipment;

const styles = {
  container: {
    padding: 0,
    width: '90%',
    display: 'flex',
    justifyContent: 'center'
  },
  table: {
    position: 'relative',
    marginBottom: '4rem',
  },
  tableRow: {
    cursor: 'pointer'
  },
  spinner: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    top: '-5px',
    opacity: '1',
    zIndex: 2,
  },
  noResults: {
    height: '100px',
  },
  deleteTextConfirm: {
    marginLeft: '-30px',
    fontWeight: 'bold',
  },
  editWidth: {
    width: '90%'
  },
  avatarContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  avatar: {
    width: '2.75rem',
    height: '2.75rem',
  },
  avatarSmallText: {
    fontSize: '0.775rem',
    width: '2.75rem',
    height: '2.75rem',
  },
  chip: {
    margin: 5,
  },
  thumbUp: {
    marginRight: 15,
    color: "#349c34"
  },
  thumbDown: {
    marginRight: 15,
    color: "#d04545"
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
  },
  cell: {
    fontSize: '0.775rem',
    padding: '0.25rem',
  },
  cellChip: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  label: {
    marginLeft: '0.5rem'
  },
   buttonFilterIcon: {
    marginLeft: 5
  },
  buttonFilter: {
    zIndex: 200,
    backgroundColor: '#008100',
    height: '2.2rem',
    width: '6.5rem',
    padding: '1rem',
    color: '#fff',
  },
  clearFilter: {
    cursor: 'pointer',
    textDecoration: 'underline',
    zIndex: 200,
    padding: '0.75rem 0.5rem',
    color: '#000',
  },
  filterContainer: {
    position: 'relative',
    width: '100%',
  },
  filterChipContainer: {
    paddingLeft: 20,
    display: 'flex',
    flexWrap: 'wrap',
  },
  filterChip: {
    cursor: 'pointer',
    margin: 5,
  },
}
